import { Component, ChangeDetectionStrategy, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxTextBoxModule, DxDropDownBoxModule, DxCheckBoxModule } from 'devextreme-angular';
import { NgIf, NgSwitch, AsyncPipe, NgFor } from '@angular/common';
import { LinkSettingView } from '../../interfaces/link-setting-view.interface';

export class DropDownDatasourceRow {
	Id: number;
	Value: string;
	Selected: boolean;
}

@Component({
    selector: 'setting-dropdown',
    templateUrl: './setting-dropdown.component.html',
    styleUrls: ['./setting-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        NgSwitch,
		NgFor,
        FormsModule,
        ReactiveFormsModule,
        DxTextBoxModule,
		DxDropDownBoxModule,
		DxCheckBoxModule,
        AsyncPipe,
    ],
})
export class SettingDropdownComponent implements OnInit {
	@Input()
	setting: LinkSettingView;

	@Input()
	dataSource: DropDownDatasourceRow[];

	selectedValues: number[];

	@Output()
	valueChanged = new EventEmitter<string>();

	selectionDebounce;

	constructor() {

	}

	ngOnInit() {
		try {
			this.selectedValues = JSON.parse(this.setting.useValue);
		} catch {
			this.selectedValues = [];
		};
		for(const row of this.dataSource) {
			row.Selected = this.selectedValues.includes(row.Id);
		}
	}

	onDropdownSelectionChanged($event, row: DropDownDatasourceRow) {
		row.Selected = $event.value;
		if($event.value) this.selectedValues.push(row.Id);
		else this.selectedValues.splice(this.selectedValues.indexOf(row.Id), 1);

		clearTimeout(this.selectionDebounce);
		this.selectionDebounce = setTimeout(() => this.valueChanged.emit(JSON.stringify(this.selectedValues)), 1000);
	}

	getTextBoxValue() {
		return `${this.selectedValues.length} selected.`;
	}
}
